import Color from 'color'
import { createUseStyles } from 'react-jss'

import {
  darkGrey,
  trafficYellowDark,
  trafficRedDark,
  trafficGreenDark,
  lightGrey,
  trafficGreenLight,
  trafficYellowLight,
  trafficRedLight,
  darkBlue,
  lightBlue
} from '../../styles/const/colors'
import { CHIP_COLORS } from '../../constants/other'
import { defaultBorderRadius, zIndex1 } from '../../styles/const/common'

export const colorsValue = {
  [CHIP_COLORS.neutral]: darkGrey,
  [CHIP_COLORS.success]: trafficGreenDark,
  [CHIP_COLORS.warning]: trafficYellowDark,
  [CHIP_COLORS.error]: trafficRedDark,
  [CHIP_COLORS.blue]: darkBlue
}

export const backgroundColorsValue = {
  [CHIP_COLORS.neutral]: lightGrey,
  [CHIP_COLORS.success]: trafficGreenLight,
  [CHIP_COLORS.warning]: trafficYellowLight,
  [CHIP_COLORS.error]: trafficRedLight,
  [CHIP_COLORS.blue]: lightBlue
}

export default createUseStyles({
  tagWrapper: {
    display: 'inline-block',
    position: ({ isBadge }) => (isBadge ? 'absolute' : 'relative'),
    top: ({ isBadge }) => (isBadge ? '-9px' : 'unset'),
    right: ({ isBadge }) => (isBadge ? '0' : 'unset'),
    padding: ({ isBadge }) => (isBadge ? '1px 5px' : 'unset')
  },
  tagCommonStyles: {
    position: 'relative',
    borderRadius: defaultBorderRadius,
    marginRight: 6,
    textTransform: 'capitalize'
  },
  tag: {
    extend: 'tagCommonStyles',
    backgroundColor: ({ isBackgroundTransparent, color }) =>
      isBackgroundTransparent ? 'transparent' : backgroundColorsValue[color],
    color: ({ color }) => colorsValue[color],
    fontSize: ({ isSmall }) => (isSmall ? 10 : 12),
    padding: ({ isSmall }) => (isSmall ? '2px 4px' : '4px 8px'),
    lineHeight: ({ isSmall }) => (isSmall ? '11px' : '14px'),
    cursor: ({ isHoverable }) => isHoverable && 'pointer',
    '&:hover': {
      backgroundColor: ({ color, isHoverable }) =>
        isHoverable && Color(backgroundColorsValue[color]).darken(0.1).rgb().string()
    },
    '&.withSubTagSeparator': {
      display: 'inline-block',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 0,
      marginRight: 0,
      zIndex: zIndex1,
      // we use these pseudo classes to create rotated border design for sub tags with custom triangles
      '&:before': {
        content: "''",
        position: 'absolute',
        top: 0,
        right: -10,
        zIndex: '-50',
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderTop: ({ color }) => `13px solid ${colorsValue[color]}`,
        borderRight: '10px solid transparent'
      },
      '&:after': {
        content: "''",
        position: 'absolute',
        top: 0,
        right: -8,
        zIndex: '-40',
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderTop: ({ color }) => `13px solid ${colorsValue[color]}`,
        borderRight: '9px solid transparent'
      }
    }
  },
  tagContent: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 6
  },
  subTag: {
    extend: 'tagCommonStyles',
    fontSize: ({ isSmall }) => (isSmall ? 10 : 12),
    padding: ({ isSmall }) => (isSmall ? '2px 4px' : '4px 8px'),
    lineHeight: ({ isSmall }) => (isSmall ? '11px' : '14px'),
    display: 'inline-block',
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    paddingLeft: '13px !important',
    color: ({ subTagColor }) => colorsValue[subTagColor],
    backgroundColor: ({ subTagColor }) => backgroundColorsValue[subTagColor]
  }
})
